"use strict";

const AvailabilityController = require('./controllers/availabilityController');
const CheckoutController = require('./controllers/checkoutController');
const MainController = require('./controllers/mainController');
const WebinarsController = require('./controllers/webinarsController');
const ParamsController = require("../params-controller");

(function () {
  const availabilityController = new AvailabilityController(),
    checkoutController = new CheckoutController(),
    mainController = new MainController(),
    webinarsController = new WebinarsController(),
    paramsController = new ParamsController();

  availabilityController.init();
  paramsController.handleIDev();
  checkoutController.init();
  mainController.init();
  webinarsController.init();

}());
